import {HTTP} from "@/http";

class EntraAccountProviderServiceClass {
  basePath = 'api/v2/remote-account-providers/entra';

  /**
   * Get all Entra account providers for a customer
   * @param {string} customerId
   * @returns {Promise<Object>}
   */
  getByCustomer(customerId) {
    return HTTP.get(this.basePath, {params: {customerId}});
  }

  /**
   * Create a new Entra account provider
   * @param {Object} provider { customerId, connectionId, groupId, role }
   * @returns {Promise<Object>}
   */
  create(provider) {
    return HTTP.post(this.basePath, provider);
  }

  /**
   * Update an existing Entra account provider
   * @param {Object} provider Provider object including its id
   * @returns {Promise<Object>}
   */
  patch(provider) {
    return HTTP.patch(`${this.basePath}/${provider.id}`, provider);
  }

  /**
   * Validate an Entra account provider without persisting it.
   * @param {Object} provider { id?, customerId, connectionId, groupId, role }
   * @returns {Promise<Object>} resolves with EntraAccountProviderValidationResponseView
   */
  validate(provider) {
    if (provider.id) {
      return HTTP.post(`${this.basePath}/${provider.id}/validate`, {
        connectionId: provider.connectionId,
        groupId: provider.groupId,
        role: provider.role,
      });
    }

    return HTTP.post(`${this.basePath}/validate`, {
      customerId: provider.customerId,
      connectionId: provider.connectionId,
      groupId: provider.groupId,
      role: provider.role,
    });
  }

  /**
   * Delete an Entra account provider
   * @param {string} id
   * @returns {Promise<Object>}
   */
  delete(id) {
    return HTTP.delete(`${this.basePath}/${id}`);
  }
}

/**
 * @type {EntraAccountProviderServiceClass}
 */
export const entraAccountProviderService = new EntraAccountProviderServiceClass();
